import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { PageBase } from '../../page.base';
import { slugify } from '../../utils/string';
import { EstablishmentRedirectionService } from 'src/app/services/establishment-redirection.service';
import { GTMService } from 'src/app/services/gtm.service';

@Component({
  selector: 'modal-coupon',
  templateUrl: './modal-coupon.component.html',
  styleUrls: ['./modal-coupon.component.scss'],
})

export class ModalCouponComponent extends PageBase implements OnChanges {
  @Input()
  public modalData: any;
  public offer: any;
  public guideOfUse: any;
  public partner: any;

  constructor(
    private establishmentRedirectionService: EstablishmentRedirectionService,
    private gtm: GTMService
    ) {
    super();
  }

  copied = false;
  appStore = false;
  playStore = false;
  loadingSubscription: Subscription;

  ngOnChanges(changes: SimpleChanges): void {  
      if (changes.modalData.currentValue) {
        if (this.modalData.modalType === 'modalCoupon') {
          this.trackingEventView('cupom-fisico:sucesso');
          this.trackingVirtualPageView('parceiro-fisico-desconto-gerado-sucesso');
        } else if (
          this.modalData.modalType === 'modalCouponRedirect' ||
          this.modalData.modalType === 'modalCouponWhatsapp' ||
          this.modalData.modalType === 'modalCouponApp'
        ) {
          this.trackingVirtualPageView('tela-desconto-gerado');
        }
      }
  }
  
  onCopy() {
    const timeOutCopy = 2000;
    this.copied = true;
    this.trackingVirtualPageView('tela-desconto-gerado-cupom-copiado');

    setTimeout(() => {
      this.copied = false;
    }, timeOutCopy);
  }

  public redirectPartner(typeUrl: string) {
    const timeOutRedirect = 4000;
    window.scrollTo(0, 0);
    let url = '';
    if (typeUrl === 'partner') {
      this.onCopy();
      url = this.modalData.partner.campaignLink;
    } else if (typeUrl === 'app-store') {
      url = this.modalData.partner.campaignLink.appStore;
    } else if (typeUrl === 'google-play') {
      url = this.modalData.partner.campaignLink.playStore;
    } else if (typeUrl === 'whatsapp') {
      url = this.modalData.partner.campaignLink;
    }
    this.establishmentRedirectionService.startLoading(url, this.modalData);
    setTimeout(() => {
      this.establishmentRedirectionService.stopLoading();
    }, timeOutRedirect);
  }

  public maskCpf() {
    if (this.modalData) {
      const { cpf } = this.modalData.user;
      return `${cpf.substring(0, 2)}.***.***-${cpf.substring(9, 11)}`;
    }
    return '';
  }

  public maskPhone() {
    if (this.modalData) {
      const { phone } = this.modalData.user;
      return `*******.${phone.substring(phone.length - 4, phone.length)}`;
    }
    return '';
  }

  public displayStores() {
    if ( /Android|Linux/i.test(navigator.userAgent) ) {
      this.playStore = true;
      this.appStore = false;
    } else if ( /iPhone|iPad|iPod/i.test(navigator.userAgent) ) {
      this.playStore = false;
      this.appStore = true;
    } else {
      this.playStore = true;
      this.appStore = true;
    }
    return true;
  }

  trackingEventButton(buttonName: string) {
    const eventContent: any = {
      event: 'interaction',
      'event-category': 'admin',
      'event-action': `${slugify(this.modalData.partner.slug)}:click`,
      'event-label': `botao:${slugify(buttonName)}`,
    };
    this.gtm.sendEvent(eventContent);
  }

  trackingEventView(eventName: string) {
    const eventContent: any = {
      event: 'interaction',
      'event-category': 'admin',
      'event-action': `${slugify(this.modalData.partner.slug)}:view`,
      'event-label': `${slugify(eventName)}`,
    };
    this.gtm.sendEvent(eventContent);
  }

  trackingVirtualPageView(pageName: string) {
    const viewContent: any = {
      event: 'virtualPageView',
      virtualPageView: `vpv/admin/parceiro/${this.modalData.partner.slug}/${pageName}`,
    };
    this.gtm.sendEvent(viewContent);
  }
}
